import { render, staticRenderFns } from "./LiveStreamItem.vue?vue&type=template&id=3612c4e4&"
import script from "./LiveStreamItem.vue?vue&type=script&lang=js&"
export * from "./LiveStreamItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports